import { plainToClass } from "class-transformer";
import { MedicineDeliveryDocument } from "src/domains/medicine-delivery/models/document";

class MedicineDeliveryDocumentMapper {
    static fromJson(json: Record<string, unknown>) {
        return plainToClass(MedicineDeliveryDocument, json);
    }

    static fromJsons(jsons: Record<string, unknown>[]) {
        return jsons.map(MedicineDeliveryDocumentMapper.fromJson);
    }
}

export { MedicineDeliveryDocumentMapper };
